/* eslint-disable */

import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { Form } from 'antd';
import dayjs from 'dayjs';

const getOrdinalSuffix = (num) => {
	const j = num % 10;
	const k = num % 100;
	if (j === 1 && k !== 11) {
		return num + 'st';
	}
	if (j === 2 && k !== 12) {
		return num + 'nd';
	}
	if (j === 3 && k !== 13) {
		return num + 'rd';
	}
	return num + 'th';
};

const GrossRentHistory = ({ data = [], index }) => {
	const form = Form.useFormInstance();
	const effectiveDateHistory = form.getFieldValue('effectiveDateHistory');

	return (
		<>
			<Typography
				sx={{
					fontSize: '13px',
					fontWeight: 'bold',
					marginBottom: '10px',
					marginTop: index === 0 ? '0px' : '10px',
				}}
			>
				{index === 0
					? 'Initial - on creation, Effective Date: ' + dayjs(effectiveDateHistory?.[index]).format('DD-MM-YYYY')
					: `${getOrdinalSuffix(index)} Modification, Effective Date: ` + dayjs(effectiveDateHistory?.[index]).format('DD-MM-YYYY')}
			</Typography>
			<TableContainer
				className="advance-amount-table"
				sx={{
					'& table, & th, & td': {
						border: '1px solid #e0e0e0',
						borderCollapse: 'collapse',
					},
					'& th, & td': {
						p: '5px',
					},
					'& td .ant-form-item': {
						marginBottom: '0px',
					},

					'& th:nth-of-type(1), & td:nth-of-type(1)': { width: '20%' } /* From/From Month */,
					'& th:nth-of-type(2), & td:nth-of-type(2)': { width: '20%' } /* To/To Month */,
					'& th:nth-of-type(3), & td:nth-of-type(3)': { width: '20%' } /* Amount/Monthly Adjustment */,
					'& th:nth-of-type(4), & td:nth-of-type(4)': { width: '20%' } /* Remarks/Total Amount */,
					'& th:nth-of-type(5), & td:nth-of-type(5)': { width: '20%' } /* Action */,
					'& table': { width: '100%' } /* Ensure table takes full container width */,
				}}
			>
				<Table aria-label="Advance Amount table">
					<TableHead>
						<TableRow>
							<TableCell sx={{ textAlign: 'center' }}>From</TableCell>
							<TableCell sx={{ textAlign: 'center' }}>To</TableCell>
							<TableCell sx={{ textAlign: 'center' }}>Amount</TableCell>

							<TableCell sx={{ textAlign: 'center' }}>Notes</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{data.length > 0 ? (
							data.map((row, index) => {
								return (
									<TableRow key={index}>
										<TableCell style={{ textAlign: 'center' }}>{row.from}</TableCell>
										<TableCell style={{ textAlign: 'center' }}>{row.to}</TableCell>
										<TableCell style={{ textAlign: 'right' }}>{row.amount}</TableCell>

										<TableCell>{row.remarks || ''}</TableCell>
									</TableRow>
								);
							})
						) : (
							<TableRow>
								<TableCell colSpan={5} style={{ textAlign: 'center' }}>
									No data available
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</>
	);
};

export default GrossRentHistory;
